import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  cloudChiprApi,
  ProviderType,
} from "../../../../../services/cloudchipr.api";
import { CloudProviderType } from "@/components/common/types/types";

export const getResourcesVisibilitiesByAccountIdsAndProviderThunk =
  createAsyncThunk(
    "liveUsageMgmt/getResourcesVisibilitiesByAccountIdsAndProvider",
    async (
      {
        accountIds,
        provider,
      }: { provider: ProviderType; accountIds: string[] },
      { dispatch },
    ) => {
      return await dispatch(
        cloudChiprApi.endpoints.getUsersMeProvidersByProviderAccountsResourcesVisibilities.initiate(
          {
            provider: provider as CloudProviderType,
            accountIds: accountIds.join(","),
          },
        ),
      ).unwrap();
    },
  );
